import React from "react";

import SupportPageHeader from "./components/page-header";
import SupportPlanCard from "./components/plan-card";

import './support.scss'

type Props = {
  children: React.ReactNode
  headerTitle?: React.ReactNode
  hideCreateButton?: boolean
  isCreatingRequest?: boolean
  onBackToSupport?(): void
  sidebar?: React.ReactNode
}

const SupportPageLayout = ({
  children,
  headerTitle,
  hideCreateButton = false,
  isCreatingRequest = false,
  onBackToSupport,
  sidebar,
}: Props) => (
  <main className='support-page'>
    <SupportPageHeader
      title={headerTitle}
      hideCreateButton={hideCreateButton}
      isCreatingRequest={isCreatingRequest}
      onBackToSupport={onBackToSupport}
    />
    <div className='support-page__layout'>
      <div className='support-page__primary-column'>
        {children}
      </div>
      <aside className='support-page__sidebar'>
        {sidebar || <SupportPlanCard />}
      </aside>
    </div>
  </main>
);

export default SupportPageLayout;
